import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ICategory} from '@netx/core-category-next/schema';

/**
 * `getCategoryData` request params
 * (what is used to send to server)
 */
export interface GetCategoryDataRequestOptions {
	id: number;
}

/**
 * `getCategoryData` request
 * (what gets sent to the server)
 */
export type GetCategoryDataRequest = [GetCategoryDataRequestOptions['id']];

/**
 * `getCategoryData` response
 * (what comes back from the server)
 */
export type GetCategoryDataResponse = SuccessResponse<GetCategoryDataResult>;

/**
 * `getCategoryData` result
 * (what is utilized from the server response)
 */
export type GetCategoryDataResult = ICategory;

export const getCategoryDataEndpoint = 'getCategoryData';

/**
 * Autolist categories
 * @param fetchParams Fetch params
 */
export const getCategoryData = async (
	{id}: GetCategoryDataRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetCategoryDataRequest = [id];

	return client
		.post<GetCategoryDataResponse>(getCategoryDataEndpoint, requestParams, {
			signal,
		})
		.then((response) => {
			const {result} = response.data;
			result.id = result.categoryid;
			// TODO: move to a util
			return {
				...result,
				...(result.categoryid === 1
					? {
							name: 'Top Level Folder (/)',
							repositorydirectory: 'Top Level Folder (/)',
					  }
					: null),
			};
		});
};
export default getCategoryData;
